import React from 'react'
import { Link } from 'react-router-dom'

import styles from './TrailPresentation.module.css'

const TrailPresentation = ({ presentation }) => {
  presentation = presentation
    .filter(item => item.entity)
    .sort((a, b) => a.entity.node.entity.weight - b.entity.node.entity.weight)

  const countImages = presentation.reduce((initial, item) => {
    return item.entity.image ? ++initial : initial
  }, 0)

  const enableImages = presentation.length === countImages

  return (
    <>
      <h4 className={styles['presentation-text']}>
        Aqui você pode conferir o que vai encontrar nesta trilha:
      </h4>
      <div className={styles.items}>
        {presentation.map((item, index) => (
          <Link key={index} to={`#${item.entity.node.entity.nid}`} className={styles['items-item']}>
            {enableImages && item.entity.image && (
              <div className={`${styles['items-item-column']} ${styles['items-item-two-columns']}`}>
                <div className={styles.image}>
                  <img
                    src={item.entity.image.entity.image.derivative.url}
                    width='375'
                    height='205'
                    alt={item.entity.image.entity.image.alt}
                  />
                </div>
              </div>
            )}
            <div
              className={`${styles['items-item-column']} ${
                styles[`items-item-${enableImages ? 'two-columns' : 'one-column'}`]
              }`}
            >
              {item.entity.tags && (
                <ul className={styles.tags}>
                  {item.entity.tags
                    .trim()
                    .split(',')
                    .map((tag, index) => (
                      <li key={index}>{tag}</li>
                    ))}
                </ul>
              )}
              {item.entity.title && <h2 className={styles.title}>{item.entity.title}</h2>}
              {item.entity.text && item.entity.text.value && (
                <div className={styles.body}>
                  <p>{item.entity.text.value}</p>
                </div>
              )}
            </div>
          </Link>
        ))}
      </div>
    </>
  )
}

export default TrailPresentation
